<template>
  <aside class="ba-sidebar-left uk-light uk-visible@m">

    <div class="ba-create-box uk-padding-small">
      <BitButton :to="{ name: 'CreateVirtualMachine'}">Create New Service</BitButton>
    </div>

    <div class="uk-padding-small">
      <ul class="uk-nav-default uk-nav-parent-icon" uk-nav="multiple: true">
        <li class="uk-nav-header ba-nav-header">
          <span class="uk-margin-small-right" uk-icon="icon: thumbnails; ratio: 1.25"></span>
          Your Services
        </li>
        <router-link :to="{ name: 'VirtualMachines' }" v-slot="{ href, route, navigate, isActive, isExactActive }">
          <li :class="[isActive && 'uk-active', isExactActive && 'uk-active']">
            <a :href="href" @click="navigate">Virtual Machines</a>
          </li>
        </router-link>

        <li class="uk-nav-divider"></li>

        <li class="uk-nav-header ba-nav-header">
          <span class="uk-margin-small-right" uk-icon="icon: credit-card; ratio: 1.25"></span>
          Billing
        </li>
        <router-link :to="{ name: 'Invoices' }" v-slot="{ href, route, navigate, isActive, isExactActive }">
          <li :class="[isActive && 'uk-active', isExactActive && 'uk-active']">
            <a :href="href" @click="navigate">Invoices</a>
          </li>
        </router-link>
        <router-link :to="{ name: 'PaymentOptions' }" v-slot="{ href, route, navigate, isActive, isExactActive }">
          <li :class="[isActive && 'uk-active', isExactActive && 'uk-active']">
            <a :href="href" @click="navigate">Payment Options</a>
          </li>
        </router-link>

        <li class="uk-nav-divider"></li>

        <li class="uk-nav-header ba-nav-header">
          <span class="uk-margin-small-right" uk-icon="icon: lifesaver; ratio: 1.25"></span>
          Support
        </li>
        <router-link :to="{ name: 'Tickets' }" v-slot="{ href, route, navigate, isActive, isExactActive }">
          <li :class="[isActive && 'uk-active', isExactActive && 'uk-active']">
            <a :href="href" @click="navigate">Tickets</a>
          </li>
        </router-link>

      </ul>
    </div>

    <div class="ba-account-balance uk-text-center">
      <div class="uk-padding-small">
        <router-link :to="{ name: 'AccountCredit' }" uk-tooltip="Add Account Credit">
          Account Balance:<br />
          <span :class="balance_color">{{ account_balance | formatCurrency }}</span>
        </router-link>
      </div>
    </div>

  </aside>

</template>

<script>
import BitButton from '@/components/common/button.vue';

import { mapActions, mapState } from "vuex";

export default {
  name: 'SideNav',
  components: {
    BitButton
  },
  computed: {
    ...mapState('credit', ['account_balance']),
    balance_color() {
      if(this.account_balance >= 0) {
        return ''
      } else {
        return 'negative_balance'
      }
    }
  },
  created() {
    this.GET_ACCOUNT_CREDIT();
    this.GET_ACCOUNT_BALANCE();
  },
  methods: {
    ...mapActions('credit', ['GET_ACCOUNT_CREDIT', 'GET_ACCOUNT_BALANCE'])
  }
}
</script>

<style scoped lang="less">
@import "../../assets/less/theme.less";

.ba-account-balance {
  position: absolute;
  background-color: rgba(0,0,0,0.09);
  bottom: 0;
  width: 240px;

  a {
    font-size: 1.1rem;

    &:hover {
      text-decoration: none;
    }

    span {
      font-size: 1.3rem;
    }
    .negative_balance {
      color: red;
    }
  }
}
.ba-create-box {
  background-color: rgba(0,0,0,0.09);
}
.ba-sidebar-left {
  position: fixed;
  box-sizing: border-box;
  top: 60px;
  bottom: 0;
  width: 240px;
  background-color: @ba-black;
  overflow-x: hidden;
}
.uk-nav-default {
  list-style: none;
  font-size: 1rem;
  li {
    a {
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
.ba-nav-header {
  margin-top: 0 !important;
  font-size: 1.05rem;

  > a {
    color: rgba(255, 255, 255, 1) !important;
    &:hover {
      color: @ba-gold !important;
    }
  }
  span {
    margin-top: -10px !important;
  }
}
</style>
